import { useEffect } from "react";

/**
 * Public payment success page. Rendered at /success (Stripe checkout success_url).
 * Kept intentionally isolated from the admin bundle — pure presentational JSX + inline styles.
 */
export default function PaymentSuccess() {
  useEffect(() => {
    document.title = "Payment successful — Ratezy";
  }, []);
  return (
    <>
      <style>{`
        :root { --bg:#07080a; --surface:#0f1113; --border:rgba(255,255,255,0.09);
                --text:#f4f4f5; --muted:#a1a1aa; --accent:#3a7cff; --success:#22c55e; }
        html,body,#root { background:var(--bg); color:var(--text);
          font-family:'Inter', system-ui, sans-serif; margin:0; min-height:100vh; }
        .ps-body { min-height:100vh; display:flex; align-items:center; justify-content:center; padding:24px; }
        .ps-card { background:var(--surface); border:1px solid var(--border); border-radius:24px;
          max-width:520px; width:100%; padding:44px 36px; text-align:center;
          box-shadow:0 40px 80px -20px rgba(0,0,0,0.6); }
        .ps-tick { width:76px; height:76px; margin:0 auto 22px;
          background:linear-gradient(135deg, var(--success), #16a34a);
          border-radius:50%; display:flex; align-items:center; justify-content:center;
          box-shadow:0 16px 32px -8px rgba(34,197,94,0.5); }
        .ps-tick svg { width:36px; height:36px; color:#fff; }
        .ps-card h1 { font-family:'Space Grotesk', sans-serif; font-size:1.8rem; margin:0 0 12px; letter-spacing:-0.02em; }
        .ps-card p { color:var(--muted); font-size:1rem; line-height:1.6; margin:0 0 18px; }
        .ps-next { background:rgba(58,124,255,0.08); border:1px solid rgba(58,124,255,0.2);
          border-radius:14px; padding:16px 18px; margin:22px 0 8px; text-align:left; }
        .ps-next strong { display:block; margin-bottom:4px; color:var(--text); font-weight:600; }
        .ps-next span { color:var(--muted); font-size:0.9rem; line-height:1.5; }
        .ps-brand { display:inline-flex; align-items:center; gap:8px; margin-top:24px;
          color:var(--muted); font-size:0.85rem; }
        .ps-brand img { height:20px; width:auto; }
      `}</style>
      <div className="ps-body" data-testid="payment-success-page">
        <main className="ps-card">
          <div className="ps-tick" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                 strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h1>Payment successful</h1>
          <p>Thanks — your subscription is confirmed. A receipt has been sent to your email.</p>
          <div className="ps-next">
            <strong>What happens next</strong>
            <span>The Ratezy team will finalise your review page and QR code, then send you the print-ready poster within one business day.</span>
          </div>
          <div className="ps-brand">
            <img src="/ratezy-logo.webp" alt="Ratezy" />
          </div>
        </main>
      </div>
    </>
  );
}
